module.exports = __webpack_public_path__ + "static/media/BJ.a6714f55.png";